const ETH = { name: "Ethereum", symbol: "ETH", decimals: 18 };
const BNB = { name: "BNB", symbol: "BNB", decimals: 18 };
const FTM = { name: "Fantom", symbol: "FTM", decimals: 18 };
export const CHAIN_ALIASES = { BSC_MAINNET: 56, FTM_MAINNET: 250, ETH_MAINNET: 1, BSC_TESTNET: 97 };

export function getAddChainParameters(chainId) {
  const chainInformation = CHAINS[chainId];
  if (!chainInformation) return chainId;
  return {
    chainId,
    chainName: chainInformation.name,
    nativeCurrency: chainInformation.nativeCurrency,
    rpcUrls: chainInformation.urls,
    blockExplorerUrls: chainInformation.blockExplorerUrls,
  };
}

export const CHAINS = {
  [CHAIN_ALIASES.BSC_MAINNET]: {
    name: "BSC Mainnet",
    blockExplorerUrls: ["https://bscscan.com"],
    nativeCurrency: BNB,
    urls: [
      "https://bsc-dataseed.binance.org",
      "https://bsc-dataseed1.binance.org",
      "https://bsc-dataseed1.defibit.io",
      "https://bsc-dataseed2.defibit.io",
      "https://bsc-dataseed1.ninicoin.io",
      "https://bsc-dataseed2.ninicoin.io",
    ],
  },
  [CHAIN_ALIASES.FTM_MAINNET]: {
    name: "FTM Mainnet",
    blockExplorerUrls: ["https://ftmscan.com"],
    nativeCurrency: FTM,
    urls: ["https://rpc.ftm.tools"],
  },
  [CHAIN_ALIASES.ETH_MAINNET]: {
    name: "ETH Mainnet",
    blockExplorerUrls: ["https://etherscan.io"],
    nativeCurrency: ETH,
    urls: ["https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161", "https://cloudflare-eth.com"],
  },
  [CHAIN_ALIASES.BSC_TESTNET]: {
    name: "BSC Testnet",
    blockExplorerUrls: ["https://testnet.bscscan.com"],
    nativeCurrency: BNB,
    urls: [
      "https://data-seed-prebsc-2-s2.binance.org:8545",
      "https://data-seed-prebsc-2-s1.binance.org:8545",
      "https://data-seed-prebsc-1-s1.binance.org:8545",
      "https://data-seed-prebsc-1-s2.binance.org:8545",
      "https://data-seed-prebsc-1-s3.binance.org:8545",
      "https://data-seed-prebsc-2-s3.binance.org:8545",
    ],
    isTestnet: true,
  },
};

export const DEFAULT_CHAIN_IDS = Object.values(CHAIN_ALIASES);
